import { api } from ".";

const basePath = "/applicants";

export const createApplicant = async ({
  name,
  phone,
  roleIds,
  contractId,
  assignedSkillIds,
  departmentIds,
  birthday,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      phone,
      roleIds,
      contractId,
      assignedSkillIds,
      departmentIds,
      birthday,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getApplicantList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteApplicant = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};
